import { render, staticRenderFns } from "./BaseTLProgress.vue?vue&type=template&id=264ceff6&"
import script from "./BaseTLProgress.vue?vue&type=script&lang=ts&"
export * from "./BaseTLProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports